import { render, staticRenderFns } from "./DialogueMessageForm.vue?vue&type=template&id=7e963b8c&"
import script from "./DialogueMessageForm.vue?vue&type=script&lang=js&"
export * from "./DialogueMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./DialogueMessageForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports